import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import { Progress, Col, Row } from 'reactstrap';

import {ReactComponent as PLAYBUTTON} from '../play.svg';
import {ReactComponent as PAUSEBUTTON} from '../pause.svg';
import {ReactComponent as MUTEBUTTON} from '../muteFull.svg';
import {ReactComponent as UNMUTEBUTTON} from '../unMuteFull.svg';


export default class VideoControls extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      error : ''
    };
  }


  componentDidMount(){

  }


  render () {
    return (
      <React.Fragment>
        <div className="videoControls">
          {!this.props.isPlaying &&
          <PLAYBUTTON
          style={{
            width:"55px",
            height:"55px",
            marginLeft:"10%",
            cursor : "pointer"
          }}
          onClick={this.props.play} />
        }
        {this.props.isPlaying &&
        <PAUSEBUTTON
        style={{
          width:"55px",
          height:"55px",
          marginLeft:"10%",
          cursor : "pointer"
        }}
        onClick={this.props.play} />
      }
          <Progress
            style={{width:"100%",
                    margin:"30px",
                    backgroundColor:"#0778ca",
                    height:"8px"
                  }}
            color="maxi-yellow"
            value={this.props.progress * 100}
          />
          {!this.props.isMuted &&
            <MUTEBUTTON
            style={{
              width:"55px",
              height:"55px",
              marginRight:"10%",
              cursor : "pointer"
            }}
            onClick={this.props.mute}
          />
          }
          {this.props.isMuted &&
            <UNMUTEBUTTON
            style={{
              width:"55px",
              height:"55px",
              marginRight:"10%",
              cursor : "pointer"
            }}
            onClick={this.props.mute}
          />
          }
        </div>
      </React.Fragment>
    );
  }
}
